import { AssetOverview } from "@app/workspaces/services/workspaces-data.service";

export class AssetOverviewModel {
    guid?: string;
    reference?: number | string;
    name?: string;
    organizationName?: string;
    userName?: string;
    description?: string;
    dateInUse?: string | null;
    dateOutOfUse?: string | null;
    thirdPartyName?: string | null;
    contractName?: string | null;

    static fromApi(dto: AssetOverview): AssetOverviewModel {
        return {
            guid: dto.guid,
            reference: dto.reference,
            name: dto.name,
            organizationName: dto.ownershipInformation?.organizationName,
            userName: dto.ownershipInformation?.userName,
            description: dto.description,
            dateInUse: dto.lifecycle?.dateInUse ?? null,
            dateOutOfUse: dto.lifecycle?.dateOutOfUse ?? null,
            thirdPartyName: dto.thirdPartyInformation?.thirdPartyName,
            contractName: dto.thirdPartyInformation?.contractName,
        };
    }
}
